// react-snap prerenders with an older bundled Chromium that predates
// String.prototype.replaceAll (Chrome 85, 2020). The ALTCHA widget calls it at
// module-registration time, which crashes the prerender. This guarded polyfill
// runs before any other module (imported first in index.tsx) so replaceAll
// exists everywhere. No-op in every real browser we support.
if (typeof String.prototype.replaceAll !== "function") {
  // eslint-disable-next-line no-extend-native, func-names
  String.prototype.replaceAll = function (search: string | RegExp, replacement: any): string {
    if (search instanceof RegExp) {
      if (!search.global) {
        throw new TypeError("replaceAll must be called with a global RegExp");
      }
      return this.replace(search, replacement);
    }
    return this.split(String(search)).join(String(replacement));
  };
}

export {};
